module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"ファサード立寄り客数"}}')
  delete Component.options._Ctor
}
